import Localize from 'react-intl-universal';

import { filterTypes } from '@components/Filters/Constants';

export const customerLoyaltySorters = (isOwnEvents, contextData) =>
  contextData?.loggedIn
    ? [
        {
          fieldName: 'startDate',
          translationKey: 'CustomerLoyaltyEvents.sortStartDateAsc',
          value: 'asc',
          iconName: 'calendar_month',
          visible: true
        },
        {
          fieldName: 'startDate',
          translationKey: 'CustomerLoyaltyEvents.sortStartDateDsc',
          value: 'desc',
          iconName: 'calendar_today',
          visible: true
        },
        {
          fieldName: 'eventName',
          translationKey: 'CustomerLoyaltyEvents.sortAZ',
          value: 'asc',
          iconName: 'text_rotation_down',
          visible: true
        },
        {
          fieldName: 'eventName',
          translationKey: 'CustomerLoyaltyEvents.sortZA',
          value: 'desc',
          iconName: 'text_rotate_up',
          visible: true
        },
        {
          fieldName: isOwnEvents ? 'status' : 'eventStatus',
          translationKey: 'CustomerLoyaltyEvents.sortStatusAsc',
          value: 'asc',
          iconName: 'south',
          visible: true
        },
        {
          fieldName: isOwnEvents ? 'status' : 'eventStatus',
          translationKey: 'CustomerLoyaltyEvents.sortStatusDsc',
          value: 'desc',
          iconName: 'north',
          visible: true
        }
      ]
    : [
        {
          fieldName: 'startDate',
          translationKey: 'CustomerLoyaltyEvents.sortStartDateAsc',
          value: 'asc',
          iconName: 'calendar_month',
          visible: true
        },
        {
          fieldName: 'startDate',
          translationKey: 'CustomerLoyaltyEvents.sortStartDateDsc',
          value: 'desc',
          iconName: 'calendar_today',
          visible: true
        },
        {
          fieldName: 'eventName',
          translationKey: 'CustomerLoyaltyEvents.sortAZ',
          value: 'asc',
          iconName: 'text_rotation_down',
          visible: true
        },
        {
          fieldName: 'eventName',
          translationKey: 'CustomerLoyaltyEvents.sortZA',
          value: 'desc',
          iconName: 'text_rotate_up',
          visible: true
        }
      ];

export const getEventFiltersConfig = (styleConfig) => [
  {
    filterType: 'calendarRange',
    name: 'dateRange',
    title: Localize.get('App.dateRange'),
    from: {
      name: 'dateRange.from',
      title: Localize.get('App.from'),
      placeholder: Localize.get('App.rangeFromDate'),
      initialState: '',
      locale: 'en-US',
      showToday: false,
      disabled: false
    },
    to: {
      name: 'dateRange.to',
      title: Localize.get('App.to'),
      placeholder: Localize.get('App.rangeToDate'),
      initialState: '',
      locale: 'en-US',
      showToday: false,
      disabled: false
    }
  },
  {
    filterType: 'checkboxGroup',
    name: 'groupTypeKey',
    title: Localize.get('CustomerLoyaltyEvents.groupTypes'),
    initialState: {},
    options: filterTypes.eventsGroupsTypes,
    showSearch: true,
    hideElement: styleConfig?.hideElements?.filter?.groupType
  },
  {
    filterType: 'checkboxGroup',
    name: 'groupTopicKey',
    title: Localize.get('CustomerLoyaltyEvents.groupTopics'),
    initialState: {},
    options: filterTypes.eventsGroupsTopics,
    showSearch: true,
    hideElement: styleConfig?.hideElements?.filter?.groupTopic
  },
  {
    filterType: 'checkboxGroup',
    name: 'eventTopicKey',
    title: Localize.get('CustomerLoyaltyEvents.eventsTopics'),
    initialState: {},
    options: filterTypes.eventsTopics,
    showSearch: true
  },
  {
    filterType: 'checkboxGroup',
    name: 'eventTypeKey',
    title: Localize.get('CustomerLoyaltyEvents.types'),
    initialState: {},
    options: filterTypes.eventsTypes,
    showSearch: true
  },
  {
    filterType: 'checkboxGroup',
    name: 'eventLanguage',
    title: Localize.get('CustomerLoyaltyEvents.languages'),
    initialState: {},
    options: filterTypes.eventsNativeLanguages,
    showSearch: true
  },
  {
    filterType: 'slider',
    name: 'eventsPrices',
    title: Localize.get('CustomerLoyaltyEvents.priceRange'),
    ariaLabel: Localize.get('Catalog.range'),
    initialState: 0,
    rangeUnit: '€',
    options: filterTypes.eventsPrices
  },
  {
    filterType: 'checkboxGroup',
    name: 'venueName',
    title: Localize.get('CustomerLoyaltyEvents.locations'),
    initialState: {},
    options: filterTypes.eventsLocations,
    showSearch: true
  },
  {
    filterType: 'checkboxGroup',
    name: 'venuecity',
    title: Localize.get('CustomerLoyaltyEvents.cities'),
    initialState: {},
    options: filterTypes.eventsVenuesCities,
    showSearch: true
  },
  {
    filterType: 'checkboxGroup',
    name: 'venuecountry',
    title: Localize.get('CustomerLoyaltyEvents.countries'),
    initialState: {},
    options: filterTypes.eventsVenuesCountries,
    showSearch: true
  }
];
